// extracted by mini-css-extract-plugin
export default {"tupacGrid":"_o-z","tupacHeader":"ap-z","tupacHeader2":"bp-z","tupacMenu":"cp-z","tupacMenu2":"dp-z","tupacMain":"ep-z","tupacMain2":"fp-z"};